export default {
  singleTitle: {
    en: 'Need a small break?',
  },
  singleText: {
    en: 'You can easily put your subscription on hold!',
  },
  personalTitle: {
    en: '{name}, are you sure?',
  },
  singlePersonalText: {
    en: 'Looks like you have some great scents coming up! You can easily just put your subscription on hold...',
  },
  unsubscribeTitle: {
    en: 'Need a small break, instead?',
  },
  unsubscribeText: {
    en: 'We understand things happen. You can easily put your subscription on hold!',
  },
  unsubscribePersonalText: {
    en: 'We understand things happen and looks like you have some great scents coming up! You can easily just put your subscription on hold...',
  },
  remind: {
    en: 'Remind me 3 day before charging time',
  },
  confirmButton: {
    en: 'Confirm my hold',
  },
  continueButton: {
    en: 'Continue cancellation',
  },
}
